import { Capacitor } from "@capacitor/core";
import { useTranslation } from "locales";
import { NavigationMenuItemInterface } from "types";
import useController from "./controller";
import { Routes } from "../../router/config";

function useViewController() {
  const { t } = useTranslation();
  const { user } = useController();
  const isNative = Capacitor.isNativePlatform();
  const allItems: NavigationMenuItemInterface[] = [
    {
      title: t("Main info"),
      name: "settings",
      icon: "signup",
      to: "/user/settings",
    },
    {
      title: t("Appointments"),
      name: "appointments",
      icon: "calendar",
      to: "/user/appointments",
    },
    {
      title: t("Balance history"),
      name: "history",
      icon: "history",
      to: "/user/transactions",
    },
    {
      title: t("Change password"),
      name: "password",
      icon: "show-off",
      to: "/user/change-password",
    },
    {
      title: t("Notifications"),
      name: "notifications",
      icon: "notification",
      to: "/user/notifications",
    },
    {
      title: t("Delete account"),
      name: "delete-account",
      icon: "close",
      to: "/user/delete-account",
      secondMenu: true,
    },
    {
      title: t("Log out"),
      name: "logout",
      icon: "logout",
      to: Routes.logout,
    },
  ];

  const itemsList = allItems.filter((item) => item.name !== "history");

  return {
    user,
    itemsList,
  };
}

export default useViewController;
